<template>
  <div class="upload" v-wechat-title="this.text">
    <div v-if="!isLoading">
      <!-- 非锁材料 -->
      <div v-if="!isUnlock">
        <template v-for="(item, index) in checkItems">
          <div class="upload-list no-bottom" :key="index" v-if="active == index">
            <!-- <van-cell-group :title="'上传'+item.name+'材料'" :border="false"> -->
            <van-cell-group :title="title" :border="false">
              <van-cell v-for="(citem, cindex) in item.data" :key="cindex" @click="goUpload(citem, item.name)" value-class="cell-value">
                <template #title>
                  <!-- <span :style="{color:'red','margin-right':citem.is_required!='1'?'12px':'5px'}">
                    {{citem.is_required!='1'?'':'*'}}
                  </span> -->
                  <span class="custom-title" :style="{color:citem.result.status=='审核不通过'?'red':''}">
                    <!-- {{citem.name+'（'+ citem.attach.length +'张）'}} -->
                    {{citem.name}}
                  </span>
                </template>
                <div>
                  <img :src="getImgSrc(citem.result.status,citem)" width="55px" />
                  <!-- <span :class="citem.result.status=='审核不通过'?'warn':(citem.result.status=='审核通过'?'success':(citem.result.status=='待审核'?'loading':''))">
                    {{citem.result.status}}</span> -->
                </div>
              </van-cell>
            </van-cell-group>
          </div>
        </template>
        <div style="margin-bottom:100px;">
          <div style="font-size:14px;color:red;margin:21px;" v-if="patient.receive_phase>1">
            项目办建议第1轮次每2个月前往项目医生出完成一次随访评估；第2、3轮次每3个月前往项目医生出完成一次随访评估。
          </div>
          <div style="font-size:12px;text-align:left;margin-bottom:50px;margin:0 20px;">
            <span v-if="field_3||field_4">*您最近一次的随访</span>
            <span v-if="field_3">时间是{{field_3}}</span>
            <span v-if="field_3&&field_4">，</span>
            <span v-if="field_4">检查部位是：{{field_4}}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 解锁材料 -->
        <template>
        <div class="upload-list" >
          <!-- <van-cell-group :title="'上传'+item.name+'材料'" :border="false"> -->
          <van-cell-group :title="text" :border="false">
            <van-cell v-for="(citem, cindex) in unlockItems" :key="cindex" @click="goUploadUnlock(citem)" value-class="cell-value">
              <template #title>
                <!-- <span :style="{color:'red','margin-right':citem.is_required!='1'?'12px':'5px'}">
                  {{citem.is_required!='1'?'':'*'}}
                </span> -->
                <span class="custom-title" :style="{color:citem.status=='审核不通过'?'red':''}">
                  <!-- {{citem.name+'（'+ citem.attach.length +'张）'}} -->
                  {{citem.name}}
                </span>
              </template>
              <div>
                <img :src="getImgSrc(citem.status,citem)" width="55px" />
                <!-- <span :class="citem.result.status=='审核不通过'?'warn':(citem.result.status=='审核通过'?'success':(citem.result.status=='待审核'?'loading':''))">
                  {{citem.result.status}}</span> -->
              </div>
            </van-cell>
          </van-cell-group>
        </div>
        </template>
      </div>


    </div>

    <div class="btn" v-if="!isLoading">
        <van-button type="default" class="up " @click="goNext" :disabled="disabled" color="#0AA8AF">{{btntxt}}</van-button>
        <!-- <van-button v-if="active != 0" type="default" class="back" @click="toPrev()">上一步</van-button> -->
    </div>
  </div>
</template>

<script>
  var jweixin = require('jweixin-module')
  import {
    GetPatient,
    CheckItemStatus,
    GetCheckItem,
    UploadPatientStatus,
    PredictUnlockQuery,
    PredictUnlockUpload,
    PredictUnlockAttachDel,
  } from '../../api/api';
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,Notify
  } from 'vant';

  Vue.use(Toast);
  export default {
    data() {
      return {
        isLoading: true,
        papid: '',
        patient_id: '',
        category: '',//患者申请,阶段审核,处方解锁
        checkItems: [],
        active: 0,
        list: [],
        btntxt: '提交',
        disabled: false,
        checked: false,
        text: '入组审核材料',
        title:'入组审核材料',
        showcheck: false,
        follow: false,

        isUnlock:false,
        unlockItems:[],


        field_3:'',//随访时间
        field_4:'',//随访检查部位

        patient:null,//患者对象
      }
    },
    computed: {
      ...mapState(['userInfo','patientInfo','patientOne']),
    },
    async mounted() {
      if (this.$route.query.active) {
        this.active = parseInt(this.$route.query.active);
      }
      if (this.$route.query.follow) {
        this.follow = this.$route.query.follow;
      }
      if (this.$route.query.category) {
        this.category = this.$route.query.category;
      }
      if (this.userInfo.patient) {
        this.papid = this.userInfo.patient.papid
        this.patient_id = this.userInfo.patient.id
      }
      await this.getData()
      window.localStorage.setItem('ischeck', 'true')
      this.$forceUpdate()
    },
    methods: {
      async getData() {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        let res={data:this.patientInfo}
        const {
          patient,
          drugstore,
          phase,
          predict,
          volunteer,
          mode_name,
          rounds_phase,
          phase_drug_field,
          phase_drug_field_3
        } = res.data;
        this.patient=patient
        if(phase_drug_field){
          this.field_3=phase_drug_field.field_3;
          this.field_4=phase_drug_field.field_4;
          if(phase_drug_field_3){
            if(!this.field_3) this.field_3=phase_drug_field_3.field_3
            if(!this.field_4) this.field_4=phase_drug_field_3.field_4
          }
        }
        if(res.data.patient.receive_phase>1){//非第一阶段
          if([3,14].includes(res.data.patient.receive_phase)){//第二,三轮次的首阶段
            this.text='上传阶段审核材料'
            this.category = '阶段审核'
            this.title=this.text
          }else{//非首阶段
            this.text='上传材料'
            this.category = '阶段审核'
            this.title='阶段审核材料'
          }
        }
        if(this.patientInfo.receive_time_unlock){//患者解锁
          this.text='上传解锁材料'
          this.category = '超出计划领药日期'
        }
        if(this.patientInfo.prescription_unlock){//患者解锁
          this.text='上传解锁材料'
          this.category = '超出处方日期'
        }
        let ci;
        if(this.text=='上传解锁材料'){//患者解锁的情况
          this.isUnlock=true;
          ci = await PredictUnlockQuery({papid: this.papid})
          this.unlockItems=ci.data.checkItem
          console.log("unlockItems",this.unlockItems)
        }else{//患者申请,阶段审核
          this.isUnlock=false;
          ci = await GetCheckItem({
            papid: this.papid,
            category: this.category,//阶段审核才传-'阶段审核',患者申请传-''
            phase: res.data.patient.receive_phase
          })
          //把所有审核项放到checkItems第一个元素的data里
          this.checkItems = [ci.data[0]]
          let temp =[]
          // let showNotice=false;
          ci.data.forEach(ele=>{ temp=[...temp,...ele.data] })
          this.checkItems[0].data=temp
          console.log("this.checkItems",this.checkItems)
        }


        // if (this.active == (this.checkItems.length - 1)) {
        //   this.btntxt = "提交"
        //   // console.log(this.active, this.btntxt, this.checkItems.length, this.checkItems)
        // }
        Toast.clear()
        this.isLoading = false
      },
      goUpload(item, name) {
        console.log("goUpload", item.category)
        this.$router.push({
          name: 'UploadItem',
          query: {
            id: item.id,
            papid: this.papid,
            category: item.category,
            active: this.active,
            follow: this.follow
          }
        })
      },
      goUploadUnlock(item){
        console.log("goUploadUnlock", item)
        this.$router.push({
          name: 'UploadItem',
          query: {
            id: item.id,
            papid: this.papid,
            category: item.type,
            active: this.active,
            follow: this.follow,
            unlock:'unlock'
          }
        })
      },
      checkchange() {
        // console.log(this.checked)
        window.localStorage.setItem('check', this.checked)
        // console.log( window.localStorage.getItem('check'))
      },
      async goNext() {
        if(this.isUnlock){//处方解锁
          this.unlockGoNext()
          return;
        }

        let item ;
        let allup;
        item = this.checkItems[this.active].data
        for (let i in item) {
          let ele = item[i]
          if (ele.result.status == "未上传" || ele.attach.length < 1) {
            if (ele.is_required == "1") {
              allup = false
              Toast('请完善资料')
              return
            }
          } else if (ele.result.status == "审核不通过" && ele.is_required == "1") {
            Toast('您有驳回的材料，请重新上传')
            allup = false
            return
          }
        }
        
        if (this.active == (this.checkItems.length - 1)) {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true
          });
          let sendData = {
            papid: this.papid,
            // category: [this.category]   患者申请/阶段审核不需要传category,后续复核(appointment)/处方解锁才传category
          }
          UploadPatientStatus(sendData).then(res => {
            this.$router.replace({
              name: "Timeline",
            });
            Toast.clear();
          }).catch(err => {
            this.disabled = false;
            Toast.clear();
            Toast(err.response.data.message);
          })
        } else if (this.active == (this.checkItems.length - 2)) {
          this.btntxt = "提交"
          this.active = this.active + 1
          this.disabled = false;
          // this.text = '上传' + this.checkItems[this.active].name + '材料'
        } else {
          this.active = this.active + 1
          this.disabled = false;
          // this.text = '上传' + this.checkItems[this.active].name + '材料'
        }
      },
      unlockGoNext(){
        let item ;
        let allup;
        item = this.unlockItems
        for (let i in item) {
          let ele = item[i]
          if (ele.status == "未上传" || ele.attach.length < 1) {
            allup = false
            Toast('请完善资料')
            return
          } else if (ele.status == "未通过") {
            //能不能上传单个材料-更新单个材料的状态-已上传的为待审核
            Toast('您有驳回的材料，请重新上传')
            allup = false
            return
          }
        }
        if (this.active == (this.unlockItems.length - 1)) {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true
          });
          let sendData = {
            papid: this.papid,
            // category: [this.category]   患者申请/阶段审核不需要传category,后续复核(appointment)/处方解锁才传category
          }
          let nullItem=[];
          item.forEach(ele=>{nullItem.push({check_item_id:ele.id})})
          PredictUnlockUpload({papid:this.papid,checkItems:nullItem}).then(res=>{
            this.$router.replace({
              name: "Timeline",
            });
            Toast.clear();
          }).catch(err=>{
            this.disabled = false;
            Toast.clear();
            Toast(err.response.data.message);
          })
        } else if (this.active == (this.unlockItems.length - 2)) {
          this.btntxt = "提交"
          this.active = this.active + 1
          this.disabled = false;
          // this.text = '上传' + this.checkItems[this.active].name + '材料'
        } else {
          this.active = this.active + 1
          this.disabled = false;
          // this.text = '上传' + this.checkItems[this.active].name + '材料'
        }
      },
      //通过状态计算图片地址
      getImgSrc(status,item){
        const fileUrl="/static/upload/"
        const format=".png"
        let imgName="awaitUpload"
        // console.log(item,status)
        if(status=="审核不通过"){
          // Notify({
          //   message: '请重新上传后提交',
          //   color: '#FF4830',
          //   background: '#FFDADB',
          // });
          imgName="refuse"
        }else if(status=="审核通过"){
          imgName="passed"
        }else if(status=="待审核"&&item.attach.length>0){//已上传
          imgName="uploaded"
        }else if(status=="待审核"){//未上传
          imgName="awaitUpload"
        // }else if(status=="待上传"){//解锁材料未上传
        //     imgName="awaitUpload"
        }else if(status=="未通过"&&item.attach.length>0){//解锁材料不通过
          imgName="refuse"
        }else{
          console.log("getImgSrc出错")
        }

        imgName=fileUrl+imgName+format

        return imgName
      },
    },
  }
</script>

<style lang='less'>
  .upload {
    // min-height: 100vh;
    width: 100%;
    margin-bottom: 50px;
    box-sizing: border-box;

    .upload-list {
      box-sizing: border-box;
      margin: 16px;
      margin-bottom:100px;
      border-radius: 10px;
      box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0);
      overflow: hidden;

      .custom-title{
        
      }
      .van-cell__title{
        flex:3 2;
      }
      .van-cell-group__title {
        background: #FFB253;
        color: #fff;
        padding: 10px;
      }

      .warn {
        color: @red;
      }

      .success {
        color: #6CF025;
      }

      .loading {
        color: #F89900;
      }
    }
    .no-bottom{
      margin-bottom:0;
    }

    .check {
      width: 92%;
      margin: 0 auto;
      font-size: 13px;

      span {
        color: #5b7096;
      }
    }
    /deep/ .cell-value{
      width:100px !important;
    }
    .btn{
      position:fixed;
      bottom:0;
      background-color: white;
      padding:10px 0 10px 0;
      border-top: 1px solid rgba(0, 0, 0, 0.05);
    }
  }
</style>